import { render, staticRenderFns } from "./TourTabsDeparturesHistoric.vue?vue&type=template&id=f446cb86&scoped=true&"
import script from "./TourTabsDeparturesHistoric.vue?vue&type=script&lang=js&"
export * from "./TourTabsDeparturesHistoric.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsDeparturesHistoric.vue?vue&type=style&index=0&id=f446cb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f446cb86",
  null
  
)

export default component.exports